/* global window */
import React, { Component } from 'react';
// components
import CardTitlePart from '../../../parts/CardTitlePart';
import AddressPart from './addressPart';
import SubTitlePart from './subTitlePart';
import BodyTextPart from './BodyTextPart';
import GhostButton from '../../../parts/GhostButton';
import TextCTA from '../../../layout/buttons/TextCTA';

class DetailsConfirmCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };

    this.handleDismissCard = this.handleDismissCard.bind(this);
  }

  handleDismissCard () {
    const { dismissCard } = this.props;

    return dismissCard()
      .catch(() => this.handleError());
  }

  render() {
    const { title, subTitle, text, cTAText } = this.props;

    return (
      <div>
      
     

      <div className="delivery__details card-title-border">
        <CardTitlePart 
          title={title} 
        />
        </div>



<div className="delivery__details sub-title-pink">
        <SubTitlePart 
          text={subTitle} 
        />
        </div>
        <AddressPart />

        
        <BodyTextPart 
          text={text} 
        />

    <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          text={cTAText}
          position={'right'}
          align={'right'}
          type={'confirm'}
          disabled={false}
          onBtnClick={this.handleDismissCard}
        />
        </div>
      </div>
    );
  }  

}

export default (DetailsConfirmCard);




// WEBPACK FOOTER //
// ./src/cards/templates/DetailsConfirmCard/index.js